import type { SVGIconComponent } from 'types/svgr';

import Image, { type ImageProps } from '@/app/components/Image';

export interface LandingPageMembershipTabContentFeaturedImageProps {
  readonly backgroundImage: ImageProps;
  readonly Icon: SVGIconComponent;
}

const LandingPageMembershipTabContentFeaturedImage = ({
  backgroundImage,
  Icon,
}: LandingPageMembershipTabContentFeaturedImageProps) => {
  return (
    <div
      className="relative hidden h-[418px] w-[300px] overflow-hidden rounded-lg lg:block"
      data-cy="landing-page-membership-tab-featured-img"
    >
      <Image
        className="absolute top-0 left-0 size-full"
        height={420}
        width={300}
        {...backgroundImage}
      />
      <div className="absolute top-0 left-0 flex size-full items-center justify-center text-white">
        <Icon height="62" width="62" />
      </div>
    </div>
  );
};

export default LandingPageMembershipTabContentFeaturedImage;
